export default class Cep {
  static async find(cep) {
    const response = await fetch(`https://brasilapi.com.br/api/cep/v2/${cep}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Origin': '*'
      }
    });
    if (!response.ok) {
      throw new Error('Erro ao buscar o CEP');
    }
    const data = await response.json();
    return data;
  }
}
